export default __webpack_public_path__ + "static/media/chimera-02.014a3734.png";